import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, DatePipe  } from '@angular/common';
import { HistoryRoutingModule } from './history-routing.module';
import { HistoryComponent } from './history.component';
import { HttpLoaderFactory, SharedModule } from '../shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MaterialprimeModule } from '../material.module';
import { HistoryDetailsComponent } from './historydetails/historydetails.component';
import { HistoryfilterComponent } from './historyfilter/historyfilter.component';
import { FormsModule } from '@angular/forms';
import { BatchUploadComponent } from './batch-upload/batch-upload.component';




@NgModule({
  declarations: [HistoryComponent, HistoryDetailsComponent, HistoryfilterComponent, BatchUploadComponent],
  imports: [
    CommonModule,
    BrowserModule,
    SharedModule,
    RouterModule,
    MaterialprimeModule,
    NgxSpinnerModule,
    HttpClientModule,
    FormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
    }),
    HistoryRoutingModule
  ],
  providers: [DatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HistoryModule { }



